import * as React from "react";
import { logError } from "utils/logger/logger";
import { ErrorMessage } from "components/layout/ErrorMessage/ErrorMessage";

interface ErrorState {
  hasError: boolean;
  errorMessage?: string;
}

export default class ErrorHandler extends React.Component<React.PropsWithChildren<{}>, ErrorState> {
  state: ErrorState = { hasError: false, errorMessage: undefined };

  static getDerivedStateFromError(error: Error): ErrorState {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logError(error, errorInfo ? errorInfo.componentStack : undefined);
  }

  render(): React.ReactNode {
    const { hasError, errorMessage } = this.state;
    const children = (this as any).props.children;
    if (hasError) {
      return <ErrorMessage message={errorMessage} />;
    }
    return children;
  }
}
